import {
  CaesarsButton,
  useIsDesktop,
  useIsXS,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Pressable, Text, View} from 'native-base';
import React, {useCallback, useState} from 'react';
import {Linking} from 'react-native';
import {useTheme} from 'styled-components/native';

import ErrorDisplay from 'components/ErrorDisplay';
import {supportPhoneNumber} from 'models/supportPhoneNumber';

export interface GenericAPIErrorDisplayProps {
  onRetryPress?: any;
}

const GenericAPIErrorDisplay: React.FunctionComponent<
  GenericAPIErrorDisplayProps
> = ({onRetryPress}) => {
  const isDesktop = useIsDesktop();
  const theme = useTheme() as any;
  const {ghostWhite, white, tuna} = theme.colors;
  const isXS = useIsXS();

  const [numRetriesLeft, setNumRetriesLeft] = useState(3);

  const localRetryPress = useCallback(() => {
    if (onRetryPress) {
      onRetryPress();
      setNumRetriesLeft(numRetriesLeft - 1);
    }
  }, [numRetriesLeft, onRetryPress]);

  const lowerDescriptionText = (
    /**
     * Nested Text compnent needs to be imported from React Native
     * if you want it to inherit the parent Text style
     */
    <View flexDir={isXS ? 'row' : 'column'} px={5} alignItems="center">
      {numRetriesLeft > 0 ? (
        <Text
          textAlign="center"
          fontFamily="body"
          fontSize={isDesktop ? '18px' : '14px'}
          lineHeight={isDesktop ? '30px' : '20px'}
          color={tuna}>
          Please try again.
        </Text>
      ) : (
        <>
          <Text
            color={tuna}
            fontFamily="body"
            fontSize={isDesktop ? '18px' : '14px'}
            lineHeight={isDesktop ? '30px' : '20px'}>
            For assistance, please call{' '}
          </Text>
          <Pressable
            _hover={{textDecoration: 'underline'}}
            onPress={() => Linking.openURL(`tel:${supportPhoneNumber}`)}>
            <Text
              color={tuna}
              fontFamily="body"
              fontWeight="bold"
              fontSize={isDesktop ? '18px' : '14px'}
              lineHeight={isDesktop ? '30px' : '20px'}
              bold>
              {supportPhoneNumber}
            </Text>
          </Pressable>
        </>
      )}
    </View>
  );

  return (
    <View
      maxWidth={isDesktop ? '1018px' : undefined}
      width="100%"
      shadow={isDesktop ? 0 : undefined}>
      <ErrorDisplay
        hasFooter={true}
        isSVG={false}
        iconName="exclamation-circle"
        iconColor="#D60000"
        iconSize={{height: 72, width: 72}}
        iconIsLight={true}
        titleText="Well, this is embarrassing."
        upperDescriptionText="A system error occurred, but we’re working on it."
        lowerDescriptionText={lowerDescriptionText}
      />
      {numRetriesLeft > 0 && (
        <View
          backgroundColor={isDesktop ? ghostWhite : white}
          px={isDesktop ? 7 : 5}
          pb={isDesktop ? 7 : 0}
          pt={isDesktop ? 7 : 0}
          display="flex"
          justifyContent={isDesktop ? 'flex-end' : 'center'}
          alignItems={isDesktop ? 'flex-end' : 'center'}>
          <View
            width={isDesktop ? undefined : '100%'}
            pb={isDesktop ? undefined : 5}>
            <CaesarsButton
              title="Try Again"
              disabled={!onRetryPress}
              onPress={localRetryPress}
              isFullWidth={!isDesktop}
            />
          </View>
        </View>
      )}
    </View>
  );
};

export default GenericAPIErrorDisplay;
